import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  ButtonBase,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { getFormattedDate } from '../../../../helpers/getDate';
import { getExtension } from '../../../../services/policy/policy.service';
import SendEmail from '../Components/SendEmail.component';

const ProductPolicy = () => {
  const { loading, policy, getPolicyById } = useVehiclesContext();
  const [details, setDetails] = useState([]);
  const [loadingHelper, setLoaderhelper] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const getDetails = async () => {
    setLoaderhelper(true);
    try {
      const extraData = await getExtension(policy.id);
      setDetails(extraData.data);
      setLoaderhelper(false);
    } catch (error) {
      setDialog(true);
      setLoaderhelper(false);
    }
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleShowDetails = () => {
    if (showDetails === false) {
      setShowDetails(true);
    } else if (showDetails === true) {
      setShowDetails(false);
    }
  };

  return (
    <>
      {/* {console.log(policy.id, "id")} */}
      <Box display={loading || loadingHelper ? 'block' : 'none'}>
        <Loader
          action={
            loadingHelper ? 'Cargando información adicional' : 'Cargando póliza'
          }
        ></Loader>
      </Box>

      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Ups, ha ocurrido un error!</Typography>
            <Box my={2}>
              <Typography>
                Hubo un error al solicitar los datos de la cobertura, espere un
                momento e intente nuevamente.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SubHeader
        content={
          <>
            <Typography variant="h6">Póliza {policy.number}</Typography>{' '}
            <Typography variant="caption">
              Es el documento principal del seguro donde se detalla la
              cobertura.
            </Typography>
          </>
        }
        actions={
          <SendEmail documentType={'policy'} /* cleanOnClose */></SendEmail>
        }
      ></SubHeader>

      <Grid container justify="center">
        {/* Vencimiento y forma de pago */}
        <Grid item xs={11} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Grid item xs={4}>
            <Box mt={3} mb={1}>
              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                Vencimiento de póliza
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2">
                {getFormattedDate(policy.expires_at)}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box mt={3} mb={1}>
              <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                Forma de pago
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2">
                {policy.payment_type_name}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Detalles de la póliza */}
        {policy.insured_items?.length > 0 ? (
          <Grid item xs={11}>
            <Box mb={3}>
              <Box mt={5} mb={1}>
                <Typography variant="body2" color="secondary">
                  {' '}
                  Detalles de la póliza{' '}
                </Typography>
              </Box>

              <List aria-label="detalles">
                {policy?.insured_items.map((item: any, index: number) => (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <OkIcon />
                    </ListItemIcon>
                    {item?.insured_amount && item?.insured_amount > 0 ? (
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant="body2">{item?.name}</Typography>
                        }
                        secondary={
                          <Typography>${item?.insured_amount}</Typography>
                        }
                      />
                    ) : (
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant="body2">{item?.name}</Typography>
                        }
                      />
                    )}
                  </ListItem>
                ))}
              </List>

              {details.length > 0 && (
                <Box my={2}>
                  <ButtonBase onClick={toggleShowDetails}>
                    <Typography variant="body2" color="secondary">
                      {' '}
                      Ver más{' '}
                    </Typography>
                  </ButtonBase>
                </Box>
              )}

              <List aria-label="detalles">
                {showDetails &&
                  details.map((accesory: any, index: number) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <OkIcon />
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant="body2">{accesory}</Typography>
                        }
                      />
                    </ListItem>
                  ))}
              </List>
            </Box>
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </>
  );
};

export default ProductPolicy;
